import { Button } from "@mui/material"
import { BenefitDto } from "api"
import { trackSuccessDownload } from "common/analytics"
import FormikForm from "common/bit/form/FormikForm"
import FormInput from "reusable/formsComp/FormInput"
import styled from "styled-components"
import { initialFormState, schema } from "./BenefitsSchema"

const API_URL = process.env.API_URL

export function formatLicenseNumber(licenceNumber: string) {
  let num = licenceNumber.split("-").join("")
  if (num.length === 7) {
    num = num.slice(0, 2) + "-" + num.slice(2, 5) + "-" + num.slice(5, 7)
  } else {
    num = num.slice(0, 3) + "-" + num.slice(3, 5) + "-" + num.slice(5, 8)
  }
  return num
}

const getBenefitUrl = (licenceNumber: string, benefit?: BenefitDto) => {
  licenceNumber = formatLicenseNumber(licenceNumber)
  return `${API_URL}/BenefitPdf?benefitId=${
    benefit?.id ?? ""
  }&serviceCenterName=${encodeURIComponent(
    benefit?.name ?? ""
  )}&licenceNumber=${licenceNumber}`
}

const StyledWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`
const StyledFormDiv = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 2px;
  width: 100%;
`

const StyledWrap = styled.div`
  width: 100%;
  /* max-width: 320px; */
`
const StyledButton = styled(Button)`
  margin: 0px 0px;
`

type Props = {
  benefit?: BenefitDto
}

const BenefitsForm = ({ benefit }: Props) => {
  return (
    <StyledWrapper>
      <FormikForm
        validationSchema={schema}
        initialValues={initialFormState}
        onSubmit={async (values) => {
          const url = getBenefitUrl(values.licenseNumber, benefit)
          window.open(url, "_blank")
          trackSuccessDownload(benefit?.name ?? "", "benefit_download")
        }}
        render={(formik) => (
          <StyledFormDiv>
            <FormInput name="licenseNumber" label="מספר לוחית רישוי" />
            <StyledWrap>
              <StyledButton
                disabled={formik.isSubmitting}
                fullWidth
                variant="text"
                type={"submit"}
              >
                הורדת ההטבה
              </StyledButton>
            </StyledWrap>
          </StyledFormDiv>
        )}
      />
    </StyledWrapper>
  )
}

export default BenefitsForm
